import { render, staticRenderFns } from "./aircraft-and-packaging.vue?vue&type=template&id=f2e9f86e&scoped=true&"
import script from "./aircraft-and-packaging.vue?vue&type=script&lang=js&"
export * from "./aircraft-and-packaging.vue?vue&type=script&lang=js&"
import style0 from "./aircraft-and-packaging.vue?vue&type=style&index=0&id=f2e9f86e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e9f86e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseLayoutPageHeader: require('/opt/cargo.front/src/components/base/layout/page-header.vue').default,BaseIcon: require('/opt/cargo.front/src/components/base/icon.vue').default,RzContainer: require('/opt/cargo.front/node_modules/@razlet/ui/lib/modules/components/container/index.js').default})
